// assets/hero.js
window.addEventListener('scroll', () => {
  const bg = document.querySelector('.hero-bg');
  if (!bg) return;
  bg.style.transform = `translateY(${window.scrollY * 0.3}px) scale(1.1)`;
});
